export const AUTH_REQUIRED_EVENT = 'verbum:auth-required';

/**
 * Открыть popup входа. nextPath используется для возврата после логина.
 */
export function requestAuthPopup(nextPath = '/', closeAll = true) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(AUTH_REQUIRED_EVENT, {
      detail: {
        nextPath: nextPath || '/',
        closeAll: Boolean(closeAll),
      },
    })
  );
}

